<template>
  <section class="user-index-container">
    <base-header v-bind="headers"
      v-on:handleCreate="handleHeaderCreate"
    />
    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="list.params"
      @handleSearch="handleSearchs"
    ></search-header>
    <base-table
      v-bind="list"
      v-on:handleSelectionChange="handleSelectKeyChange"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
      @handleStatus="handleModelStatus"
      @handleEdit="handleTableReset"
      @handleSend="handleTableSend"
    ></base-table>
    <form-dialog
      ref="addDialog"
      :loading="addFormLoading"
      :form="addForm"
      :rules="addRules"
      :buttons="addButtons"
      :formItems="addFormItems"
      v-on:handleConfirm="handleConfirmAdd"
      v-on:handleConfirmRole="handleConfirmRole"
    ></form-dialog>
    <form-dialog
      title="重置密码"
      ref="updateDialog"
      :loading="updateFormLoading"
      :form="updateForm"
      :rules="updateRules"
      :formItems="updateFormItems"
      :buttons="updateButtons"
      v-on:handleConfirm="handleConfirmUpdate"
    ></form-dialog>
    <msg-dialog
      v-bind="msgDialog"
      v-on:handleConfirm="handleConfirmMsg"
      v-on:handleCancel="hideMsgDialog"
    />
  </section>
</template>

<script>
import user from './user'
const columns = [
  {
    prop: 'username',
    label: '用户名',
    scopeType: 'link',
    href: '/memberManage/chiefEditor/create',
    width: '122px'
  },
  {
    prop: 'email',
    label: '电子邮箱',
    minWidth: '120px'
  },
  {
    prop: 'userExt.realname',
    label: '真实姓名',
    minWidth: '120px'
  },
  {
    prop: 'roleNames',
    label: '所属角色',
    minWidth: '120px'
  },
  {
    prop: 'enabled',
    label: '状态',
    scopeType: 'switch',
    type: 'Status'
  }
]

export default {
  name: 'userIndex',
  mixins: [user],
  data () {
    return {
      list: {
        columns,
        showSelection: false,
        api: 'fetchMemberManageEditorPage',
        params: { 'enabled': '', 'roleid': '', 'key': '' },
        handleColumn: [
          {
            type: 'Edit',
            name: '重置密码',
            notDisabled: true,
            power: 'deleteAble',
            icon: 'zhongzhimima'
          },
          {
            type: 'Send',
            name: '发送邀请',
            notDisabled: true,
            power: 'deleteAble',
            icon: 'fabu'
          }
        ],
        handleColumnProp: {
          label: '操作',
          width: '280',
          align: 'left'
        }
      },
      headers: {
        buttons: [
          {
            type: 'Create',
            text: '新建',
            icon: 'xinjian',
            notDisabled: true
          }
        ],
        title: '',
        showAlertIcon: true,
        content: '任何用户不可禁用或启用自己；'
      },
      searchHeader: {
        searchItems: [
          {
            type: 'select',
            label: '状态：',
            value: 'enabled',
            style: {
              width: '100px'
            },
            options: [
              {
                value: '',
                label: '所有'
              },
              {
                value: '1',
                label: '启用'
              },
              {
                value: '0',
                label: '禁用'
              }
            ]
          },
          {
            type: 'select',
            value: 'roleid',
            label: '所属角色：',
            placeholder: '请选择',
            optionLabel: 'roleName',
            optionValue: 'id',
            style: {
              width: '120px'
            },
            options: []
          },
          {
            type: 'searchInput',
            value: 'key',
            placeholder: '请输入关键字'
          }
        ]
      }
    }
  },
  activated () {
    if (this.$route.query.type === 'list') {
      this.fetchTableApi()
      this.$router.push({ query: { type: '' } })
    }
  },
  methods: {
    // handleFilterParams (params, name = 'list') {
    //   if (params instanceof Object && this[name].filterParams instanceof Array) {
    //     let p = Object.assign({}, params)
    //     this.list.filterParams.forEach(d => {
    //       delete p[d]
    //     })
    //     return p
    //   }
    //   return params
    // },
    // 表格操作按钮
    handleTableEdit (data, btn) {
      this.updateForm.username = data.username
      this.updateForm.id = data.id
      this.$refs.updateDialog.showDialog()
    },
    // 顶部操作按钮
    handleSearchs (data) {
      this.fetchTableApi()
    },
    handleHeaderCreate () {
      this.$refs.addDialog.showDialog()
    },
    handleModelStatus (row, index) {
      if (row.enabled) {
        this.fetchMemberManageEditorOn([row.id])
      } else {
        this.fetchMemberManageEditorOff([row.id])
      }
    },
    // 启用
    fetchMemberManageEditorOn (ids, type) {
      this.list.loading = true
      this.$request.fetchMemberManageEditorOn({ ids: ids, type: this.type }).then(res => {
        if (res.code === 200) {
          this.fetchTableApi()
          this.type = 1
        } else if (res.code === 14023) {
          this.type = 2
          this.fetchTableApi()
        }
        this.hideMsgDialog()
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    },
    // 禁用
    fetchMemberManageEditorOff (ids, type) {
      this.list.loading = true
      this.$request.fetchMemberManageEditorOff({ ids: ids, type: this.type }).then(res => {
        if (res.code === 200) {
          this.type = 1
          this.fetchTableApi()
        } else if (res.code === 14023) {
          this.type = 2
          this.fetchTableApi()
        }
        this.hideMsgDialog()
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    },
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content.map((d, i) => {
          d.disabled = !d.managerAble
          d.disabledStatus = !d.deleteAble
          return d
        })
        this.list.totalCount = res.data.totalElements
      }
    },
    fetchMemberManageRolesList () {
      this.$request.fetchMemberManageRolesList({ filter: true }).then(res => {
        if (res.code === 200) {
          this.addFormItems.find(d => d.prop === 'roleid').options = res.data
          let arr2 = [{ roleName: '所有', id: '' }]
          this.searchHeader.searchItems.find(d => d.value === 'roleid').options = arr2.concat(res.data)
        }
      })
    },
    handleTableReset (row, btn) {
      this.msgDialog.type = 'Reset'
      this.msgDialog.content = '密码将被重置为123456, 请确认？'
      this.msgDialog.data = row.id
      this.showMsgDialog()
    },
    handleTableSend (row, btn) {
      this.msgDialog.type = 'Send'
      this.msgDialog.content = '发送邀请后密码将被重置, 请确认？'
      this.msgDialog.data = row.id
      this.showMsgDialog()
    },
    // 弹出框操作按钮
    handleConfirmMsg (type) {
      switch (type) {
        case 'Reset':
          this.fetchMemberManageEditorResetPwd(this.msgDialog.data)
          break
        case 'Send':
          this.fetchMemberManageEditorSendEmail(this.msgDialog.data)
          break
      }
    },
    fetchMemberManageEditorResetPwd (id) {
      this.list.loading = true
      var params = {
        id: id
      }
      this.$request.fetchMemberManageEditorResetPwd(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchTableApi()
        } else if (res.code === 14023) {}
        this.hideMsgDialog()
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    },
    fetchMemberManageEditorSendEmail (id) {
      this.list.loading = true
      var params = {
        ids: [id]
      }
      this.$request.fetchMemberManageEditorSendEmail(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchTableApi()
        } else if (res.code === 14023) {}
        this.hideMsgDialog()
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    }
  },
  mounted () {
    this.fetchMemberManageRolesList()
  }
}
</script>
<style lang="scss" scoped>
.box-items{
    padding: 0 9px;
  }
</style>
